// extracted by mini-css-extract-plugin
export default {"image":"achievements_image__7ebqr","nameCell":"achievements_nameCell__YwtZm"};